import { useContext } from 'react';
import { ProvidersContext } from '../context';
export var useInlineCommentSubscriberContext = function useInlineCommentSubscriberContext() {
  var providers = useContext(ProvidersContext);
  if (!providers) {
    return null;
  }
  var updateSubscriber = providers.inlineComment.updateSubscriber;
  return updateSubscriber || null;
};